class GlobalAccordion extends window.HTMLElement {
  constructor() {
    super();
    // 获取single-open属性 是否只打开一个
    this.singleOpen = this.dataset.singleOpen;
    // 获取content-border属性 内容部分是否需要下边框
    this.hasContentBorder = this.dataset.contentBorder;
    // 获取展开后的颜色
    this.expandedColor = this.dataset.expandedColor;
    // 获取最大显示数量，默认5个
    this.maxVisible = parseInt(this.dataset.maxVisible || "5");
    // 获取展开的文案
    this.expandText = this.dataset.expandText || "Read More";
    // 获取收起的文案
    this.collapseText = this.dataset.collapseText || "Collapse";

  }

  connectedCallback() {
    const headers = this.querySelectorAll(".accordion-header");
    const headersParents = this.querySelectorAll(".accordion-item");
    const singleOpen = this.singleOpen === "true";
    const hasContentBorder = this.hasContentBorder === "true";
    const expandedColor = this.expandedColor;
    const maxVisible = this.maxVisible;
    const expandText = this.expandText;
    if (headersParents.length > maxVisible) {
      const toggleButton = document.createElement("button");
      toggleButton.textContent = expandText;
      toggleButton.className = "accordion-toggle-btn";

      let expanded = false;

      // 隐藏超过 maxVisible 的 header
      headersParents.forEach((header, index) => {
        if (index >= maxVisible) {
          header.style.display = "none";
        } else if (index === maxVisible - 1) {
          // 给最后一个可见项添加样式类
          header.classList.add("last-visible");
        }
      });

      toggleButton.addEventListener("click", () => {
        expanded = !expanded;
        toggleButton.textContent = expanded ? this.collapseText : expandText;

        headersParents.forEach((header, index) => {
          if (index >= maxVisible) {
            if (expanded) {
              header.style.display = "block";
            } else {
              header.style.display = "none";
            }
          }
          
          // 管理 last-visible 类
          if (expanded) {
            // 展开时，移除所有 last-visible 类，只给真正的最后一个添加
            header.classList.remove("last-visible");
          } else {
            // 收起时，给第 maxVisible-1 个添加 last-visible 类
            if (index === maxVisible - 1) {
              header.classList.add("last-visible");
            } else {
              header.classList.remove("last-visible");
            }
          }
        });
      });

      this.appendChild(toggleButton);
    }

    headers.forEach((header) => {
      header.addEventListener("click", function () {
        const content = this.nextElementSibling;
        const iconContainer = this.querySelector(".icon-container");
        const expanded = this.getAttribute("aria-expanded") === "true";
        // 图标切换逻辑
        const collapsedIcon = iconContainer.querySelector(".collapsed-icon");
        const expandedIcon = iconContainer.querySelector(".expanded-icon");
        const arrowIcon = iconContainer.querySelector(".arrow-icon");

        if (singleOpen) {
          headers.forEach((otherHeader) => {
            if (otherHeader !== this) {
              otherHeader.setAttribute("aria-expanded", "false");
              const otherContent = otherHeader.nextElementSibling;
              const otherIconContainer =
                otherHeader.querySelector(".icon-container");
              const otherCollapsedIcon =
                otherIconContainer.querySelector(".collapsed-icon");
              const otherExpandedIcon =
                otherIconContainer.querySelector(".expanded-icon");
              const otherArrowIcon =
                otherIconContainer.querySelector(".arrow-icon");

              otherContent.style.maxHeight = "0";

              // 其他项的图标切换
              if (otherCollapsedIcon && otherExpandedIcon) {
                // 两个自定义图标
                otherCollapsedIcon.style.opacity = "1";
                otherExpandedIcon.style.opacity = "0";
              } else if (otherArrowIcon) {
                // 一个自定义图标或默认图标
                otherArrowIcon.style.transform = "rotate(180deg)";
              }

              if (hasContentBorder) {
                otherContent.firstElementChild?.style.setProperty(
                  "border-bottom",
                  "none"
                );
              }
              otherContent.style.borderBottom = "none";
              otherHeader.style.setProperty("color", "");
            } else {
              otherHeader.style.setProperty("color", expandedColor);
            }
          });
        }

        // 当前项的展开/收起
        if (expanded) {
          // 收起
          this.setAttribute("aria-expanded", "false");
          this.style.color = "";
          content.style.maxHeight = "0";

          // 当前项图标切换
          if (collapsedIcon && expandedIcon) {
            // 两个自定义图标
            collapsedIcon.style.opacity = "1";
            expandedIcon.style.opacity = "0";
          } else if (arrowIcon) {
            // 一个自定义图标或默认图标
            arrowIcon.style.transform = "rotate(180deg)";
          }

          if (hasContentBorder) {
            content.firstElementChild?.style.setProperty(
              "border-bottom",
              "none"
            );
          }
        } else {
          // 打开
          this.setAttribute("aria-expanded", "true");
          content.style.maxHeight = content.scrollHeight + 1 + "px";

          // 当前项图标切换
          if (collapsedIcon && expandedIcon) {
            // 两个自定义图标
            collapsedIcon.style.opacity = "0";
            expandedIcon.style.opacity = "1";
          } else if (arrowIcon) {
            // 一个自定义图标或默认图标
            arrowIcon.style.transform = "rotate(0deg)";
          }

          if (hasContentBorder) {
            content.firstElementChild?.style.setProperty(
              "border-bottom",
              "1px solid #eaeaea"
            );
          }
        }
      });
    });
  }
}

window.customElements.define("global-accordion", GlobalAccordion);
